import client from '../axios';
import { get, post, setSession } from '../service';

class Session {
  constructor(token, expiresIn) {
    this.token = token;
    this.expiry = new Date().getTime() + expiresIn * 1000;
  }
}

export const login = async (username, password) => {
  const response = await client.post('/auth/login', {
    email: username,
    password,
  });

  if (response.status === 200) {
    const responseData = response.data;

    if (responseData.message === 'User Logged In Successfully!') {
      const authResponse = responseData?.data?.authResponse;
      const userData = responseData?.data?.userData;
      const councilData = responseData?.data?.councilData;

      const session = new Session(authResponse?.AccessToken, authResponse?.ExpiresIn);

      setSession(session);

      return {
        session,
        userData,
        councilData,
      };
    } else {
      throw new Error('Not Implemented yet');
    }
  }

  throw new Error('Login failed');
};

export const registration = async (payload) => {
  const response = await client.post('/auth/register', payload);

  if (response.status === 200) {
    const data = response.data;
    return data;
  }

  throw 'Registration failed';
};

export const forgotPassword = async (email) => {
  const response = await client.post('/auth/forgot-password', {
    email: email,
  });

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  return undefined;
};

export const resetPassword = async (email, password, code) => {
  const response = await client.post('/auth/reset-password', {
    email,
    password,
    code,
  });

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  return undefined;
};

export const resendVerificationCode = async (email) => {
  const response = await client.post('/auth/resend-verification-code', {
    email: email,
  });

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  return undefined;
};

export const confirmUser = async (email, code) => {
  const response = await client.post('/auth/confirm-user', {
    email,
    code,
  });

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  return undefined;
};

export const changePassword = async (payload) => {
  const response = await post('/auth/change-password', payload);

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  return undefined;
};

export const updateEmail = async (payload) => {
  try {
    const response = await post('/auth/update-email', payload);

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(error?.response?.data?.detail);
  }
};

export const verifyEmail = async (payload) => {
  const response = await post('/auth/verify-email', payload);

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  return undefined;
};

export const resendEmailVerificationCode = async () => {
  const response = await get('/auth/resend-email-verification-code');

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  return undefined;
};
